"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[655],{

/***/ 4336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);







var CardTitle = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0;padding-block-end:16px;padding-inline:16px;display:flex;justify-content:space-between;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{padding-inline:0;}"),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                className: "section-title",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0;display:inline-flex;align-items:center;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("h2", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin:0;font-size:18px;line-height:1.5;letter-spacing:0.02em;"),
                                children: props.children
                            }),
                            props.helpText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props.helpProps), {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("margin-left:3px;vertical-align:sub;"),
                                children: props.helpText
                            }))
                        ]
                    }),
                    props.sub ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:13px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";margin-left:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                        children: props.sub
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("display:grid;place-items:center;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:13px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";margin-left:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: props.right
                })
            })
        ]
    });
};


/***/ }),

/***/ 33879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ SNSLinks; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
;// CONCATENATED MODULE: ./components/atoms/icons/Wantedly.tsx
// svg is editted version of the offcial site: https://wantedlyinc.com/ja/brand_assets



var Wantedly = function(param) {
    var _color = param.color, color = _color === void 0 ? dist/* colors.black10 */.O9.black10 : _color, _size = param.size, size = _size === void 0 ? 25 : _size;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        version: "1.1",
        id: "レイヤー_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 900 900",
        // wantedly icon is subtly smaller than other icons
        width: "".concat(size * 1.12, "px"),
        height: "".concat(size * 1.12, "px"),
        color: color,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("polygon", {
            points: "100,208.6 200,208.6 350,570.7 400,450 300,208.6 400,208.6 450,329.3 500,208.6 600,208.6 500,450 550,570.7 700,208.6 800,208.6 600,691.4 500,691.4 450,570.7 400,691.4 300,691.4 "
        })
    });
};

// EXTERNAL MODULE: ./components/atoms/SocialIcon.tsx
var SocialIcon = __webpack_require__(99129);
;// CONCATENATED MODULE: ./components/atoms/SNSLinks.tsx





var SNSLinks = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;color:", props.color, ";"),
        className: props.className,
        children: [
            props.twitter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: props.twitter,
                target: "_blank",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:1rem;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIcon/* TwitterIcon */.Zm, {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", props.color, ";"),
                    size: props.iconSize
                })
            }),
            props.facebook && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: props.facebook,
                target: "_blank",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-right:1rem;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialIcon/* FacebookIcon */.Vq, {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", props.color, ";"),
                    size: props.iconSize
                })
            }),
            props.wantedly && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                href: props.wantedly,
                target: "_blank",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wantedly, {
                    color: props.color,
                    size: props.iconSize
                })
            })
        ]
    });
};


/***/ }),

/***/ 86996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ IPOIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var _IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96747);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);





var IPOIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: props.isHiddenTooltip === true ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__/* .IcomoonIcon */ .g, {
            name: "ipo",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:#e0ce2e;font-size:21px;vertical-align:text-bottom;"),
            className: props.className
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tooltip */ .u, {
                label: "IPO（調査終了）",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__/* .IcomoonIcon */ .g, {
                    name: "ipo",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:#e0ce2e;font-size:21px;vertical-align:text-bottom;"),
                    className: props.className
                })
            })
        })
    });
};


/***/ }),

/***/ 23581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ EmptyCard; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);




var EmptyCard = function(props) {
    var _children;
    var text = (_children = props.children) !== null && _children !== void 0 ? _children : "表示するデータがありません";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Card.Content */ .Zb.Content, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
                className: "empty",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("display:flex;align-items:center;justify-content:center;color:#999;font-size:14px;padding:5px;"),
                "data-test-id": props.dataTestId,
                children: text
            })
        })
    });
};


/***/ }),

/***/ 53565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zv": function() { return /* binding */ InViewForActiveTab; },
/* harmony export */   "ji": function() { return /* binding */ setupActiveTabs; },
/* harmony export */   "ze": function() { return /* binding */ createInViewEventQueue; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42708);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);







var STICKY_HEADER_OFFSET = "-220px 0px 0px 0px";
var InViewForActiveTab = function(props) {
    var mobileOffset = props.mobileOffset || props.offset;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)({
        threshold: [
            0,
            1
        ],
        rootMargin: props.stickyOffset || STICKY_HEADER_OFFSET
    }), 2), ref1 = ref[0], inView = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        props.onChangeActive(props.tabName, inView);
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(AnchorWithOffset, {
                id: props.tabName,
                offset: props.offset,
                mobileOffset: mobileOffset
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                ref: ref1,
                id: props.tabName + "-contents",
                className: props.className,
                children: props.children
            })
        ]
    });
};
var AnchorWithOffset = function(param) {
    var id = param.id, offset = param.offset, mobileOffset = param.mobileOffset;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        id: "".concat(id),
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:block;position:relative;top:", offset, ";visibility:hidden;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{top:", mobileOffset, ";}")
    });
};
var createInViewEventQueue = function() {
    var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50;
    var queue = [];
    var handle = null;
    var push = function(tab, inView, timeoutFn) {
        queue.push([
            tab,
            inView
        ]);
        if (handle) {
            clearTimeout(handle);
        }
        handle = setTimeout(timeoutFn, duration);
    };
    var apply = function(activeTabs) {
        var newTabs = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, activeTabs);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = queue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_step.value, 2), tab = _value[0], state = _value[1];
                newTabs[tab] = state;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        queue = [] // clear
        ;
        return newTabs;
    };
    return [
        push,
        apply
    ];
};
var setupActiveTabs = function(list) {
    var init = function() {
        return Object.fromEntries(list.map(function(tab) {
            return [
                tab,
                false
            ];
        }));
    };
    var first = function(activeTabs) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tab = _step.value;
                if (activeTabs[tab]) {
                    return tab;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    return [
        init,
        first
    ];
};


/***/ }),

/***/ 20438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MobileGuestFloatingBanner; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useTimeout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28547);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48261);







var MobileGuestFloatingBanner = function(props) {
    var isAnimateTriggered = (0,_hooks_useTimeout__WEBPACK_IMPORTED_MODULE_3__/* .useTimeout */ .K)(1500);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
        href: _lib_url__WEBPACK_IMPORTED_MODULE_4__/* .downloadDocumentUrl */ .Qf,
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("a", {
            "data-testid": "mobile-floating-banner",
            id: "".concat(props.trackingIdPrefix, "-mobile-floating-banner"),
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:none;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{display:block;background:rgba(0,0,0,0.85);height:64px;width:calc(100% - 16px);border-radius:16px;position:fixed;bottom:", isAnimateTriggered ? "8px" : "-64px", ";transition:bottom 0.25s cubic-bezier(0.175,0.885,0.32,1.275);left:8px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";z-index:90;}"),
            target: "_blank",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("height:100%;padding:8px 16px;display:flex;align-items:center;justify-content:space-between;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("flex-grow:1;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("display:flex;flex-direction:column;align-items:center;line-height:1.5;letter-spacing:0.02em;"),
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-size:12px;"),
                                    children: "\\ スタートアップ情報 /"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                                    "data-testid": "text",
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";font-size:20px;// 横幅がかなり狭い場合の対応\n                  ", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.max(340), "{font-size:16px;}"),
                                    children: "3分でわかるスピーダ"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("background:#0071e3;border-radius:32px;padding:10px 12px;white-space:nowrap;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";font-size:12px;line-height:1;"),
                        children: "ダウンロード"
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 54146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ MobileGuestSlideBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);








var MobileGuestSlideBanner = function(props) {
    var sliderSettings = {
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        swipeToSlide: true,
        touchThreshold: 10
    };
    var articles = props.slideBannerArticles;
    if (!articles || (articles === null || articles === void 0 ? void 0 : articles.length) === 0) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        "data-testid": "guest-mobile-slide-banner-section",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:none;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{display:block;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";padding:24px 16px 8px 16px;}"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("line-height:1.25;letter-spacing:0.02em;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";margin-bottom:16px;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";margin-bottom:4px;"),
                        children: "スタートアップ投資・協業の情報収集に"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:20px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";"),
                        "data-testid": "main-caption",
                        children: "お役立ち情報をチェック"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("width:100%;margin-bottom:40px;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, sliderSettings), {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(".slick-slide{padding-left:8px;}.slick-dots{bottom:-30px;line-height:0;> li{margin:0;> button::before{left:auto;top:auto;content:'';width:8px;height:8px;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray50 */ .O9.gray50, ";border-radius:100%;transform:translate(-50%,-50%);opacity:1;}&.slick-active > button::before{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray90 */ .O9.gray90, " !important;}}}"),
                    children: articles.map(function(article, index) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(SlideBanner, {
                            imageUrl: article.articleBannerImageUrl,
                            href: article.articleUrl,
                            id: "".concat(props.trackingIdPrefix, "-sb-image") + ("00" + (index + 1)).slice(-2)
                        }, index);
                    })
                }))
            })
        ]
    });
};
var SlideBanner = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("[data-index='0'] &{margin-left:8px;}", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.max(320), "{width:240px;height:240px;}"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: props.href,
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
                id: props.id,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("img", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border-radius:4px;"),
                    src: props.imageUrl,
                    width: "280",
                    height: "280",
                    "data-testid": "banner-image"
                })
            })
        })
    });
};


/***/ }),

/***/ 27322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* unused harmony export pageNumbers */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44908);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);






var Pagination = function(props) {
    if (!props.count) {
        return null;
    }
    var offset = (props.page - 1) * props.limit;
    var total = Math.ceil(props.count / props.limit);
    var current = Math.floor(offset / props.limit);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("display:flex;justify-content:center;"),
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Pagination.Previous */ .tl.Previous, {
                    disabled: current === 0,
                    as: "a",
                    onClick: function() {
                        if (current === 0) {
                            return;
                        }
                        props.setPage(props.page - 1);
                    }
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Pagination.List */ .tl.List, {
                    children: pageNumbers(total, current).map(function(p, i) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: p === -1 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Pagination.Ellipsis */ .tl.Ellipsis, {}) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Pagination.Item */ .tl.Item, {
                                active: current === p,
                                onClick: function() {
                                    props.setPage(p + 1);
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                                    children: p + 1
                                })
                            }, p)
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Pagination.Next */ .tl.Next, {
                    disabled: current === total - 1,
                    as: "a",
                    onClick: function() {
                        if (current === total - 1) {
                            return;
                        }
                        props.setPage(props.page + 1);
                    }
                })
            ]
        })
    });
};
var FIXED_COUNT = 2;
var MID_COUNT = 1;
var pageNumbers = function(total, currnet) {
    var head = range(FIXED_COUNT);
    var mid = range(MID_COUNT * 2 + 1, currnet - MID_COUNT);
    var tail = range(FIXED_COUNT, total - FIXED_COUNT);
    var list = lodash_uniq__WEBPACK_IMPORTED_MODULE_2___default()((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(head).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(mid), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(tail))).filter(function(v) {
        return v >= 0 && v < total;
    });
    return insertEllipsis(list);
};
function insertEllipsis(list) {
    var ret = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(list);
    for(var i = 0; i < ret.length - 1; i++){
        if (ret[i + 1] - ret[i] !== 1) {
            ret.splice(i + 1, 0, -1);
            i += 1;
        }
    }
    return ret;
}
var range = function(n) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var list = [];
    for(var i = start; i < start + n; i++){
        list.push(i);
    }
    return list;
};


/***/ }),

/***/ 65013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ ThumbnailFloatingBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/atoms/icons/CrossIcon.tsx


var CrossIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M6.0006 4.82166L10.1256 0.696655L11.3039 1.87499L7.17893 5.99999L11.3039 10.125L10.1256 11.3033L6.0006 7.17832L1.8756 11.3033L0.697266 10.125L4.82227 5.99999L0.697266 1.87499L1.8756 0.696655L6.0006 4.82166Z",
            fill: "white"
        })
    });
};

;// CONCATENATED MODULE: ./components/common/ThumbnailFloatingBanner.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                      vertical-align: bottom;\n                    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ThumbnailFloatingBanner = function(props) {
    var bannerItems = props.floatingBanner !== null ? props.floatingBanner : [
        {
            articleBannerImageUrl: "/static/images/seminor/slide_desktop_01.png",
            articleUrl: "https://newspicks.com/news/999999/",
            newsId: 999999
        },
        {
            articleBannerImageUrl: "/static/images/seminor/slide_desktop_02.jpg",
            articleUrl: "https://newspicks.com/news/888888/",
            newsId: 888888
        }, 
    ];
    var generateTrackingId = function(index) {
        return "".concat(props.trackingIdPrefix, "-fb-image") + ("00" + (index + 1)).slice(-2);
    };
    var ref = (0,react.useState)(bannerItems[0].articleUrl), href = ref[0], setHref = ref[1];
    var ref1 = (0,react.useState)(generateTrackingId(0)), id = ref1[0], setId = ref1[1];
    var onSlideChange = function(currentSlide) {
        setHref(bannerItems[currentSlide].articleUrl);
        setId(generateTrackingId(currentSlide));
    };
    var settings = {
        fade: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        afterChange: onSlideChange,
        pauseOnHover: false
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    id: id,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "data-testid": "thumbnail-floating-banner",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;right:24px;bottom:24px;width:280px;border-radius:8px;overflow:hidden;z-index:20;background-color:", dist/* colors.white00 */.O9.white00, ";box-shadow:0px 4px 24px rgb(0 0 0 / 12%);transition:all 0.4s ease 0s;&:hover{box-shadow:0px 8px 32px rgba(0,0,0,0.16);}", dist.mq.untilMedium, "{display:none;}"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:280px;"),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                                    children: bannerItems.map(function(b, i) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                            src: b.articleBannerImageUrl,
                                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject())
                                        }, i);
                                    })
                                }))
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:8px 0;width:280px;background-color:", dist/* colors.white00 */.O9.white00, ";display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:125%;letter-spacing:0.02em;color:", dist/* colors.black10 */.O9.black10, ";"),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:11px;"),
                                        "data-testid": "sub-caption",
                                        children: "スタートアップ投資・協業の情報収集に"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-weight:", dist/* font.weight.bold */.LZ.weight.bold, ";font-size:18px;"),
                                        "data-testid": "main-caption",
                                        children: "お役立ち情報をチェック"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                "data-testid": "thumbnail-floating-banner-close",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;height:28px;width:28px;right:16px;bottom:204px;z-index:21;background-color:", dist/* colors.black10 */.O9.black10, ";border-radius:50%;display:flex;justify-content:center;align-items:center;transition:background-color 0.2s ease;cursor:pointer;&:hover{background-color:", dist/* colors.black30 */.O9.black30, ";transition:background-color 0.2s ease;}", dist.mq.untilMedium, "{display:none;}"),
                onClick: props.onClose,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CrossIcon, {})
            })
        ]
    });
};


/***/ }),

/***/ 39347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ NPFeedPublisherAndPublishedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57923);





var NPFeedPublisherAndPublishedDate = function(param) {
    var publisher = param.publisher, publishedDate = param.publishedDate, _lineHeight = param.lineHeight, lineHeight = _lineHeight === void 0 ? 1.0 : _lineHeight, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "14px" : _fontSize, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
        className: className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("font-size:", fontSize, ";line-height:", lineHeight, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textLight */ .O9.textLight, ";display:flex;flex-flow:row nowrap;"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
                className: "np-feed-publisher",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("display:inline-block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:min-content;height:100%;max-width:580px;overflow:hidden;"),
                children: publisher
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("margin:0px 4px;"),
                children: "・"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
                className: "np-feed-publish-date",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("word-break:keep-all;"),
                children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_4__/* .formatDateByDistanceToNow */ .Wz)(publishedDate)
            })
        ]
    });
};


/***/ }),

/***/ 45270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SH": function() { return /* binding */ NewsPicksFeedSearchResultItem; }
/* harmony export */ });
/* unused harmony exports DesktopNewsPicksFeedSearchResultItem, MobileNewsPicksFeedSearchResultItem */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48261);
/* harmony import */ var _atoms_LineClampText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89277);
/* harmony import */ var _NPFeedPublisherAndPublishedDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39347);
/* harmony import */ var _PickersIcons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3278);











var NewsPicksFeedSearchResultItem = function(props) {
    var articleUrl = (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .addNewsPicksTrackingParam */ .al)(props.articleUrl, props.newsId);
    var pickersForDisplay = props.pickers.slice(0, 5);
    var image = props.image || "/static/images/top/np-feed-blank-banner.jpg";
    var bannerLinkId = props.index ? "".concat(props.classPrefix, "-news-banner-").concat(props.index) : "";
    var titleLinkId = props.index ? "".concat(props.classPrefix, "-news-title-").concat(props.index) : "";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{display:none;}"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(DesktopNewsPicksFeedSearchResultItem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
                    articleUrl: articleUrl,
                    pickers: pickersForDisplay,
                    image: image,
                    bannerLinkId: bannerLinkId,
                    titleLinkId: titleLinkId
                }))
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:none;", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{display:block;}"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(MobileNewsPicksFeedSearchResultItem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
                    articleUrl: articleUrl,
                    pickers: pickersForDisplay,
                    image: image,
                    bannerLinkId: bannerLinkId,
                    titleLinkId: titleLinkId
                }))
            })
        ]
    });
};
var DesktopNewsPicksFeedSearchResultItem = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
        className: "news-item",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:flex;justify-content:space-between;align-items:center;height:108px;padding:16px 24px 16px 10px;"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:flex;margin:0 16px 0 0;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                        className: "banner",
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("width:144px;margin-right:16px;display:flex;align-items:center;justify-content:center;flex-shrink:0;border-radius:2px;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                            href: props.articleUrl,
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("a", {
                                id: props.bannerLinkId,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("position:relative;border-radius:2px;&:after{position:absolute;display:block;content:'';top:0;left:0;height:100%;width:100%;background-color:transparent;opacity:0.08;border-radius:2px;transition:background-color 0.2s ease;}&:hover:after{background-color:#000000;transition:background-color 0.2s ease;}"),
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("img", {
                                        src: (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .resizeBannerImageUrl */ .QQ)(props.image, 600, 315),
                                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:block;<<<<<<< HEAD\n=======\n                    width:100%;>>>>>>> 3a5d45a37c (企業ページの角丸とか)\n                    object-fit:contain;border-radius:2px;aspect-ratio:1.91 / 1;")
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                                href: props.articleUrl,
                                passHref: true,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("a", {
                                    id: props.titleLinkId,
                                    className: "title",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("& > span{margin-bottom:4px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;transition:text-decoration 0.2s ease 0s;}}"),
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_LineClampText__WEBPACK_IMPORTED_MODULE_4__/* .LineClampText */ .R, {
                                        lineNumber: 1,
                                        size: "14px",
                                        height: 1.5,
                                        children: props.title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_NPFeedPublisherAndPublishedDate__WEBPACK_IMPORTED_MODULE_5__/* .NPFeedPublisherAndPublishedDate */ .c, {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("margin-bottom:4px;"),
                                publisher: props.publisher,
                                publishedDate: props.publishedDate,
                                fontSize: "12px",
                                lineHeight: 1.25
                            }),
                            props.description && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_LineClampText__WEBPACK_IMPORTED_MODULE_4__/* .LineClampText */ .R, {
                                className: "description",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black30 */ .O9.black30, ";"),
                                lineNumber: 2,
                                size: "12px",
                                height: 1.5,
                                children: props.description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("height:100%;width:214px;display:flex;align-items:center;flex-shrink:0;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("width:116px;margin:0 16px 0 4px;flex-shrink:0;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_PickersIcons__WEBPACK_IMPORTED_MODULE_6__/* .PickersIcons */ .q, {
                            className: "np-pickers",
                            pickers: props.pickers
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black30 */ .O9.black30, ";text-align:left;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("span", {
                                className: "pick-count",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";margin-right:4px;"),
                                children: props.pickCount
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("span", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("font-size:12px;"),
                                children: "Picks"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var MobileNewsPicksFeedSearchResultItem = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
        className: "news-item",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("padding:16px 24px;"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("margin-right:8px;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                            href: props.articleUrl,
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("a", {
                                id: props.titleLinkId,
                                className: "title",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("& > span{font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";text-decoration:underline solid transparent;transition:text-decoration 0.2s ease 0s;&:hover{text-decoration:underline solid Currentcolor;transition:text-decoration 0.2s ease 0s;}}"),
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_LineClampText__WEBPACK_IMPORTED_MODULE_4__/* .LineClampText */ .R, {
                                    lineNumber: 2,
                                    size: "15px",
                                    height: 1.5,
                                    children: props.title
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                        className: "banner",
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("height:59px;width:112px;display:flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden;"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                            href: props.articleUrl,
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("a", {
                                id: props.bannerLinkId,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("position:relative;border-radius:2px;&:after{position:absolute;display:block;content:'';top:0;left:0;height:100%;width:100%;background-color:transparent;border-radius:2px;opacity:0.08;transition:background-color 0.2s ease;}&:hover:after{background-color:#000000;transition:background-color 0.2s ease;}"),
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("img", {
                                        src: (0,_lib_url__WEBPACK_IMPORTED_MODULE_3__/* .resizeBannerImageUrl */ .QQ)(props.image, 600, 315),
                                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:block;width:100%;object-fit:contain;aspect-ratio:1.91 / 1;")
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_NPFeedPublisherAndPublishedDate__WEBPACK_IMPORTED_MODULE_5__/* .NPFeedPublisherAndPublishedDate */ .c, {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("margin-bottom:10px;"),
                publisher: props.publisher,
                publishedDate: props.publishedDate,
                fontSize: "12px",
                lineHeight: 1.25
            }),
            props.description && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_atoms_LineClampText__WEBPACK_IMPORTED_MODULE_4__/* .LineClampText */ .R, {
                className: "description",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black30 */ .O9.black30, ";margin-bottom:16px;"),
                lineNumber: 4,
                size: "13px",
                height: 1.5,
                children: props.description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("display:flex;align-items:flex-end;"),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_PickersIcons__WEBPACK_IMPORTED_MODULE_6__/* .PickersIcons */ .q, {
                        className: "np-pickers",
                        pickers: props.pickers
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black30 */ .O9.black30, ";text-align:left;padding-bottom:4px;margin-left:8px;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("span", {
                                className: "pick-count",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";font-size:16px;line-height:100%;margin-right:2px;"),
                                children: props.pickCount
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("span", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)("font-size:14px;line-height:100%;"),
                                children: "Picks"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 5836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ NewsPicksStaticBanner; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48261);





var NewsPicksStaticBanner = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: props.staticBanner && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: (0,_lib_url__WEBPACK_IMPORTED_MODULE_2__/* .addNewsPicksTrackingParam */ .al)(props.staticBanner.articleUrl, props.staticBanner.newsId),
            passHref: true,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                id: props.trackingId,
                className: "np-static-image-banner",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("position:relative;width:1200px;height:150px;max-width:100%;&:after{position:absolute;display:block;content:'';top:0;left:0;height:100%;width:100%;background-color:transparent;opacity:0.08;transition:background-color 0.2s ease;}&:hover:after{background-color:#000000;transition:background-color 0.2s ease;}"),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("img", {
                        alt: "NewsPicks banner image",
                        src: props.staticBanner.articleBannerImageUrl,
                        width: "1200",
                        height: "150",
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("vertical-align:bottom;")
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 3278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PickersIcons; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            position: relative;\n            display: inline-block;\n            box-sizing: content-box;\n            width: 24px;\n            height: 24px;\n            border-radius: 50%;\n            border: 2px solid white;\n            top: 0%;\n            left: ",
        ";\n            z-index: ",
        ";\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PickersIcons = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("height:", 24 + 2 * 2, "px;margin-right:-", 6 * (props.pickers.length - 1), "px;"),
        children: props.pickers.map(function(p, i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("img", {
                alt: "picker icon",
                className: "np-feed-picker-icon",
                css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), -6 * i + "px", 18 - i),
                src: p.image ? p.image : "/static/images/top/np-picker-blank-avatar.png"
            }, i);
        })
    });
};


/***/ }),

/***/ 28547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useTimeout = function(timeout) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isTimeout = ref[0], setIsTimeout = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer = setTimeout(function() {
            setIsTimeout(true);
        }, timeout);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return isTimeout;
};


/***/ }),

/***/ 13173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gx": function() { return /* binding */ fetchNPFeedsByCompanyShortname; },
  "_J": function() { return /* binding */ fetchNPFeedsByInvestorShortname; }
});

// UNUSED EXPORTS: getNPFeeds

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./lib/log.ts
var log = __webpack_require__(79240);
// EXTERNAL MODULE: ./lib/api/common.ts + 3 modules
var common = __webpack_require__(6140);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./lib/url.ts
var lib_url = __webpack_require__(48261);
;// CONCATENATED MODULE: ./lib/api/np/common.ts





var defaultHeaders = {
    "Content-Type": "application/json"
};
var callVerticalApi = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(path) {
        var options, url, response, json;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    url = lib_url/* verticalApiEndpoint */.$v + path;
                    return [
                        4,
                        fetch(url, (0,_object_spread/* default */.Z)({
                            headers: defaultHeaders,
                            mode: "cors"
                        }, options))
                    ];
                case 1:
                    response = _state.sent();
                    if (!!response.ok) return [
                        3,
                        2
                    ];
                    throw new common/* ApiError */.MS(response, "Request failed: ".concat(response.status, " url: ").concat(url, " method: ").concat(options.method ? options.method : "GET"));
                case 2:
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    json = _state.sent();
                    return [
                        2,
                        json
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function callVerticalApi(path) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./lib/api/np/feed.ts





var getNPFeeds = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var response, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        callVerticalApi("/v1/feeds?theme=startup")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.feeds.filter(function(item) {
                            return !restrictedPublishers.includes(item.publisher);
                        })
                    ];
                case 2:
                    e = _state.sent();
                    (0,log/* printError */.O)(e);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNPFeeds() {
        return _ref.apply(this, arguments);
    };
}();
var fetchNPFeedsByCompanyShortname = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(shortname) {
        var response, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,common/* callAPI */.F)("".concat(common/* basePath */.sb, "/companies/").concat(shortname, "/np_feeds"))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.feeds.filter(function(item) {
                            return !restrictedPublishers.includes(item.publisher);
                        })
                    ];
                case 2:
                    e = _state.sent();
                    (0,log/* printError */.O)(e);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchNPFeedsByCompanyShortname(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var fetchNPFeedsByInvestorShortname = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(shortname) {
        var response, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,common/* callAPI */.F)("".concat(common/* basePath */.sb, "/investors/").concat(shortname, "/np_feeds"))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.feeds.filter(function(item) {
                            return !restrictedPublishers.includes(item.publisher);
                        })
                    ];
                case 2:
                    e = _state.sent();
                    (0,log/* printError */.O)(e);
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchNPFeedsByInvestorShortname(shortname) {
        return _ref.apply(this, arguments);
    };
}();
var restrictedPublishers = [
    "AFPBB News",
    "CNET Japan",
    "ZDNET Japan",
    "Reuters"
];


/***/ }),

/***/ 86234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BC": function() { return /* binding */ scrollToRef; },
/* harmony export */   "E6": function() { return /* binding */ scrollToId; },
/* harmony export */   "XT": function() { return /* binding */ pageFromQuery; },
/* harmony export */   "ZF": function() { return /* binding */ usePageChange; },
/* harmony export */   "z$": function() { return /* binding */ pageToOffset; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var pageFromQuery = function(query) {
    var limit = query.limit ? parseInt(query.limit.toString(), 10) : 20;
    var offset = query.offset ? parseInt(query.offset.toString(), 10) : 0;
    return {
        limit: limit,
        offset: offset
    };
};
var pageToOffset = function(page) {
    var pageCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return (page - 1) * pageCount;
};
var usePageChange = function(params) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), mounted = ref[0], setMounted = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), isPaging = ref1[0], setIsPaging = ref1[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        setMounted(true);
    }, []);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var fn = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!params.dispatchOnMount && !mounted) {
                                return [
                                    2
                                ];
                            }
                            setIsPaging(true);
                            return [
                                4,
                                params.onChange(params.page)
                            ];
                        case 1:
                            _state.sent();
                            setIsPaging(false);
                            if (mounted) {
                                params.afterChange && params.afterChange(params.page);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fn() {
                return _ref.apply(this, arguments);
            };
        }();
        fn();
    }, [
        params.page
    ]);
    return {
        isPaging: isPaging
    };
};
var scrollToRef = function(params) {
    var ref;
    var elm = (ref = params.ref) === null || ref === void 0 ? void 0 : ref.current;
    var offset = params.offset || 0;
    if (elm) {
        var ref1;
        var top = ((ref1 = elm.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.top) + window.scrollY - offset;
        window.scroll({
            top: top,
            behavior: "smooth"
        });
    }
};
var scrollToId = function(id, options) {
    var elm = document.getElementById(id);
    if (elm) {
        var ref;
        var ref1;
        window.scroll({
            top: ((ref = elm.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.top) + window.scrollY - ((ref1 = options === null || options === void 0 ? void 0 : options.offset) !== null && ref1 !== void 0 ? ref1 : 0),
            behavior: "smooth"
        });
    }
};


/***/ }),

/***/ 39250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ toLowerCase; },
/* harmony export */   "e": function() { return /* binding */ formatLastFundingType; }
/* harmony export */ });
var formatLastFundingType = function(roundType) {
    return roundType.replace("post_ipo", "Post-IPO").replace("pre_seed", "Pre-Seed").replace("non_equity", "Non-equity").split("_").map(function(it) {
        return it.charAt(0).toUpperCase() + it.slice(1);
    }).join(" ");
};
var toLowerCase = function(roundType) {
    return roundType.replace("Post-IPO", "post_ipo").replace("Pre-Seed", "pre_seed").replace("Non-equity", "non_equity").split(" ").map(function(it) {
        return it.charAt(0).toLowerCase() + it.slice(1);
    }).join("_");
};


/***/ })

}]);